import { useEffect, useState } from "react";
import { motion } from "framer-motion";

/** Fixed cinematic background plate with pointer parallax. Never carries text. */
export const Plate = ({ src, scale = 1.06, depth = 14 }) => {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const onMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      setPos({ x: -x * depth, y: -y * depth });
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, [depth]);

  return (
    <>
      <motion.div
        className="plate"
        aria-hidden
        initial={{ opacity: 0, scale: scale + 0.05 }}
        animate={{ opacity: 1, scale, x: pos.x, y: pos.y }}
        transition={{
          opacity: { duration: 1.6, ease: "easeOut" },
          scale: { duration: 2.4, ease: "easeOut" },
          x: { type: "spring", stiffness: 40, damping: 20 },
          y: { type: "spring", stiffness: 40, damping: 20 },
        }}
        style={{ backgroundImage: `url(${src})` }}
      />
    </>
  );
};

export default Plate;
